
import { defineComponent } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '@/assets/translation'

export default defineComponent({
  props: {
    titleOverride: { type: String, required: false, default: undefined },
    textOverride: { type: String, required: false, default: undefined },
    buttonTitleOverride: { type: String, required: false, default: undefined },
  },
  setup() {
    return {
      ...setupTranslationPrefixer('matrix-cookies-consent'),
    }
  },
})
